import Model from 'flarum/common/Model';
export default class Sticker extends Model {
  category() {
    return Model.attribute('category').call(this);
  }
  categoryName() {
    return Model.attribute('categoryName').call(this);
  }
  title() {
    return Model.attribute('title').call(this);
  }
  textToReplace() {
    return Model.attribute('textToReplace').call(this);
  }
  path() {
    return Model.attribute('path').call(this);
  }
}
flarum.reg.add('ramon-stickers', 'common/models/Sticker', Sticker);